import {
  StyledCashInput,
  StyledCurrency,
  StyledInput,
} from './cash-input.styles';

declare type ValueType = string | number;

export interface CashInputProps {
  isValid: boolean;
  currency: string;
  amount: number;
  precision?: number;
  min?: number;
  max?: number;
  disabled?: boolean;
  onChange: (value: ValueType) => void;
}

export function CashInput({
  onChange,
  currency,
  amount,
  precision,
  min,
  max,
  disabled,
  isValid,
}: CashInputProps) {
  return (
    <StyledCashInput isValid={isValid}>
      <StyledCurrency>{currency}</StyledCurrency>
      <StyledInput
        data-testid="cash-input"
        type="number"
        size="small"
        precision={precision}
        min={min ? min : 0}
        max={max}
        value={amount}
        onChange={onChange}
        disabled={disabled}
        bordered={false}
      />
    </StyledCashInput>
  );
}

export default CashInput;
